import React, { useCallback } from "react";
import _ from 'lodash';
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { useAlert, useUserInfo } from "../../hooks";

import { TYPE } from "../../constant";
import { appKillFunc } from "../../utils/utilityEtc";

const KillAppButton = ({
  type,
  action = '',
}) => {
  const { info } = useUserInfo();
  const [Alert] = useAlert();
  const history = useHistory();
  const pmInfo = useSelector(state => state.pmNotice.info);
  const deviceInfo = useSelector( state => state.deviceInfo );

  const handleClick = useCallback(() => {
    if (process.env.REACT_APP_ENV === 'local') {
      let message = "";
      _.forEach(info, function(value, key) {
        message +=`${key}: ${value}</br>`
      });
      Alert(message);
    } else {
      if (
        deviceInfo.type === TYPE.DEVICE.PC
        || action === 'goBack'
      ) {
        history.push('/');
      } else {
        appKillFunc();
      }
    }
    
  }, [info, pmInfo]);

  return (
    <>
      <button
        className="btn_exit hide_m"
        type="button"
        onClick={handleClick}
      >
        <img
          src={
            type === "GM"
              ? `${process.env.PUBLIC_URL}/static/images/icon/ic_back@2x.png`
              : `${process.env.PUBLIC_URL}/static/images/icon/ic_back@2x.png`
          }
          alt=""
        />
      </button>
    </>
  );
};

export default KillAppButton;
